import styled from 'styled-components'
import { LazyMotion, m } from 'framer-motion'

import { CssUnit } from '@/types'

const loadFeatures = () => import('./features.js').then(res => res.default)

const Container = styled(m.div)`
  overflow: hidden;
`

type RevealProps = {
  isOpen?: boolean
  children: React.ReactNode
  height?: CssUnit
}

const variants = (height?: CssUnit) => ({
  open: {
    opacity: 1,
    height: height || 'auto',
    display: 'block'
  },
  closed: { opacity: 0, height: 0, transitionEnd: { display: 'none' } }
})

const Reveal: React.FC<RevealProps> = ({ isOpen, children, height }) => {
  return (
    <LazyMotion features={loadFeatures}>
      <Container
        initial={isOpen ? 'open' : 'closed'}
        animate={isOpen ? 'open' : 'closed'}
        inherit={false}
        transition={{ ease: 'easeInOut' }}
        variants={variants(height)}
      >
        {children}
      </Container>
    </LazyMotion>
  )
}

export default Reveal
